<template>
    <section
        id="how_it_work"
        class="relative overflow-hidden bg-[#f0f4f7] py-16 md:py-20"
    >
        <!-- мягкие фоновые пятна -->
        <div class="pointer-events-none absolute inset-0">
            <div
                class="absolute -left-20 top-10 h-[260px] w-[260px] rounded-full bg-[#ffc400]/10 blur-3xl"
            ></div>
            <div
                class="absolute right-0 top-0 h-[320px] w-[320px] rounded-full bg-white/60 blur-3xl"
            ></div>
            <div
                class="absolute bottom-0 right-[12%] h-[220px] w-[220px] rounded-full bg-[#dbe5ec]/60 blur-3xl"
            ></div>
        </div>

        <div class="relative z-10 container">
            <p
                class="mb-4 text-xs font-semibold uppercase tracking-[0.12em] text-[#7d8794] md:mb-3"
            >
                Используем индивидуальный подход к каждому клиенту
            </p>

            <div class="mb-10 flex items-center gap-6 md:mb-14">
                <h2
                    class="shrink-0 text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                >
                    Наши преимущества
                </h2>
                <div class="hidden h-px w-full bg-[#c8d0d8] md:block"></div>
            </div>

            <div class="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:items-start lg:gap-8">
                <!-- Левая часть -->
                <div class="lg:col-span-5">
                    <div
                        class="relative overflow-hidden rounded-[28px] border border-white/70 bg-white/70 p-6 shadow-lg md:p-8"
                    >
                        <div
                            class="absolute right-0 top-0 h-24 w-24 rounded-full bg-[#ffc400]/10 blur-2xl"
                        ></div>

                        <div
                            class="relative text-[15px] leading-[1.9] text-[#667180] md:text-[16px]"
                        >
                            Мы предпринимаем усилия в области исследований,
                            предлагаем инновационные решения, разрабатываем
                            высокотехнологичные продукты и достигаем конкретных
                            результатов для улучшения эффективности управления и
                            развития вашего бизнеса.
                        </div>

                        <div
                            @click.prevent="callbackStore.showBaseCallbackPopup({ title: 'Получить консультацию', description: 'Получить консультацию' })"
                            class="relative mt-6 inline-flex h-[56px] w-full cursor-pointer items-center justify-center rounded-2xl bg-[#ffc400] px-6 text-[16px] font-extrabold text-black transition duration-300 hover:-translate-y-[2px] hover:bg-[#eab800] hover:shadow md:mt-8 md:w-auto md:min-w-[240px]"
                        >
                            Получить консультацию
                        </div>
                    </div>
                </div>

                <!-- Правая часть -->
                <div class="lg:col-span-7">
                    <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
                        <div
                            v-for="item in advantages"
                            :key="item.title"
                            class="group relative overflow-hidden rounded-[24px] border border-white/80 bg-white/85 p-6 shadow transition duration-300 hover:-translate-y-1 hover:shadow-lg md:p-7"
                        >
                            <div
                                class="absolute right-0 top-0 h-20 w-20 rounded-full bg-[#ffc400]/[0.08] blur-2xl transition duration-300 group-hover:bg-[#ffc400]/[0.14]"
                            ></div>

                            <div class="relative mb-5 flex items-center gap-4">
                                <div
                                    class="flex h-[54px] w-[54px] shrink-0 items-center justify-center rounded-2xl bg-[#ffc400] text-black shadow transition duration-300 group-hover:scale-105"
                                >
                                    <component
                                        :is="item.icon"
                                        class="h-6 w-6"
                                    />
                                </div>

                                <h3
                                    class="text-[18px] font-extrabold leading-[1.25] tracking-[-0.02em] text-[#16181d]"
                                >
                                    {{ item.title }}
                                </h3>
                            </div>

                            <p
                                class="relative text-sm leading-[1.75] text-[#707987] md:text-[15px]"
                            >
                                {{ item.text }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { useCallbackStore } from "@js/store/CallbackStore.js";
import IconGlobe from "@js/components/Icons/IconGlobe.vue";
import IconFilter from "@js/components/Icons/IconFilter.vue";
import IconChartLineUp from "@js/components/Icons/IconChartLineUp.vue";
import IconChat from "@js/components/Icons/IconChat.vue";

const advantages = [
    {
        title: 'Разносторонний опыт',
        text: 'Имеем практический опыт сотрудничества с компаниями из разных отраслей и хорошо понимаем их специфику.',
        icon: IconGlobe,
    },
    {
        title: 'Индивидуальный подход',
        text: 'Анализируем процессы бизнеса, подбираем оптимальные решения и адаптируем их под конкретные задачи.',
        icon: IconFilter,
    },
    {
        title: 'Прогрессивные решения',
        text: 'Используем современные технологии и проверенные сервисы, ориентируясь на актуальные мировые подходы.',
        icon: IconChartLineUp,
    },
    {
        title: 'Поддержка клиента',
        text: 'Сопровождаем проект на всех этапах, обучаем пользователей и обеспечиваем стабильную техническую поддержку.',
        icon: IconChat,
    },
]

const callbackStore = useCallbackStore();
</script>
